var CristalloPricing = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // shared/pricing.js
  var pricing_exports = {};
  __export(pricing_exports, {
    FIELDS: () => FIELDS,
    PRODUCTS: () => PRODUCTS,
    RULES: () => RULES,
    calculate: () => calculate,
    getModel: () => getModel,
    validate: () => validate
  });
  var __cxT = (k, d) => typeof window !== "undefined" && window.cxT && window.cxT[k] || d;
  var FIELDS = {
    leva: { label: __cxT("field_left", "Leva strana"), acc: __cxT("field_left_acc", "levu stranu"), unit: "cm" },
    desna: { label: __cxT("field_right", "Desna strana"), acc: __cxT("field_right_acc", "desnu stranu"), unit: "cm" },
    vrata: { label: __cxT("field_door", "\u0160irina vrata"), acc: __cxT("field_door_acc", "\u0161irinu vrata"), unit: "cm" },
    sirina: { label: __cxT("field_width", "\u0160irina"), acc: __cxT("field_width_acc", "\u0161irinu"), unit: "cm" },
    duzina: { label: __cxT("field_length", "Du\u017Eina"), acc: __cxT("field_length_acc", "du\u017Einu"), unit: "cm" },
    visina: { label: __cxT("field_height", "Visina"), acc: __cxT("field_height_acc", "visinu"), unit: "cm" },
    duzinaOgrade: { label: __cxT("field_railing", "Du\u017Eina ograde"), acc: __cxT("field_railing_acc", "du\u017Einu ograde"), unit: "cm" }
  };
  var RULES = {
    // LPO: "Tuš kabina 135"
    kabina135: {
      fields: [
        { key: "leva", min: 15, max: 100 },
        { key: "desna", min: 15, max: 100 },
        { key: "vrata", min: 30, max: 150 },
        { key: "visina", min: 100, max: 300 }
      ],
      // (leva + desna + širina vrata) × visina × 1 RSD po cm²
      addon: (d) => (d.leva + d.desna + d.vrata) * d.visina * 1,
      montaza: 6e3
    },
    // LPO: "Dimenzije sa visinom" (Alfa, Linea)
    saVisinom: {
      fields: [
        { key: "sirina", min: 30, max: 200 },
        { key: "duzina", min: 30, max: 200 },
        { key: "visina", min: 100, max: 300 }
      ],
      // (širina + dužina) × visina × 1 RSD po cm²
      addon: (d) => (d.sirina + d.duzina) * d.visina * 1,
      montaza: 6e3
    },
    // LPO: "Dimenzije bez visine" (Flat)
    bezVisine: {
      fields: [
        { key: "sirina", min: 30, max: 200 },
        { key: "visina", min: 100, max: 300 }
      ],
      // m² × 9.100 RSD
      addon: (d) => d.sirina * d.visina / 1e4 * 9100,
      montaza: 6e3
    },
    // LPO: "Paravan"
    paravan: {
      fields: [
        { key: "sirina", min: 30, max: 200 },
        { key: "visina", min: 100, max: 300 }
      ],
      // Isto kao trenutni LPO: (š × v / 8000) × 8000 = 1 RSD po cm² (10.000 RSD/m²)
      addon: (d) => d.sirina * d.visina / 8e3 * 8e3,
      montaza: 2e3
    },
    // Staklena ograda: cena varijante = cena PO METRU (montaža uračunata).
    // Ispod 1 m računa se 1 m, preko toga tačno po centimetru.
    ograda: {
      perMeter: true,
      fields: [
        { key: "duzinaOgrade", min: 10, max: 5e3 }
      ],
      meters: (d) => Math.max(1, d.duzinaOgrade / 100),
      addon: (d, base) => (Math.max(1, d.duzinaOgrade / 100) - 1) * base,
      montaza: 0
    }
  };
  var PRODUCTS = {
    "tus-kabina-sa-sarkama-na-135c": "kabina135",
    "tus-kabina-alfa-sa-sarkama": "saVisinom",
    // Alfa Pivot
    "luksuzna-tus-kabina-po-meri": "saVisinom",
    // Alfa Slide
    "kabina-sarke": "saVisinom",
    // Linea Pivot
    "tus-kabina-bocna-klizna": "saVisinom",
    // Linea Slide
    "tus-kabina-ravna-sa-sarkama": "bezVisine",
    // Flat Pivot
    "tus-kabina-ravna-klizna": "bezVisine",
    // Flat Slide
    "paravan": "paravan",
    // Walk in paravan
    "staklena-ograda": "ograda"
    // Staklena ograda
  };
  function getModel(handle) {
    const ruleKey = PRODUCTS[handle];
    if (!ruleKey) return null;
    const rule = RULES[ruleKey];
    return {
      ruleKey,
      perMeter: !!rule.perMeter,
      montaza: rule.montaza,
      fields: rule.fields.map((f) => ({ ...f, ...FIELDS[f.key] }))
    };
  }
  function validate(handle, input) {
    const model = getModel(handle);
    if (!model) return { ok: false, errors: { _: __cxT("unknown_product", "Nepoznat proizvod") }, values: {} };
    const values = {};
    const errors = {};
    for (const f of model.fields) {
      const raw = input ? input[f.key] : void 0;
      const n = typeof raw === "number" ? raw : parseFloat(String(raw != null ? raw : "").replace(",", "."));
      if (!Number.isFinite(n)) {
        errors[f.key] = __cxT("error_enter", "Unesite {field}").replace("{field}", FIELDS[f.key].acc);
        continue;
      }
      if (n < f.min) {
        errors[f.key] = __cxT("error_min", "Mora biti minimum {min} cm").replace("{min}", f.min);
        continue;
      }
      if (n > f.max) {
        errors[f.key] = __cxT("error_max", "Mo\u017Ee biti maksimum {max} cm").replace("{max}", f.max);
        continue;
      }
      values[f.key] = n;
    }
    return { ok: Object.keys(errors).length === 0, values, errors };
  }
  function calculate(handle, input, { basePrice, montaza = false } = {}) {
    const v = validate(handle, input);
    if (!v.ok) return { ok: false, errors: v.errors };
    const rule = RULES[PRODUCTS[handle]];
    const base = Number(basePrice) || 0;
    const dimensions = rule.addon(v.values, base);
    const montazaPrice = montaza && rule.montaza > 0 ? rule.montaza : 0;
    return {
      ok: true,
      values: v.values,
      meters: rule.meters ? rule.meters(v.values) : void 0,
      base,
      dimensions,
      montaza: montazaPrice,
      total: base + dimensions + montazaPrice
    };
  }
  return __toCommonJS(pricing_exports);
})();